<template>
  <v-dialog class="dialog" @click:outside="close" width="350px" v-model="isLeaveDialog">
    <v-card class="pa-7" color="#21343b" width="auto">
      <v-row>
        <v-col cols="12">
          <span style="font-weight: 400; font-size: 15px; color: white; align-self: center">
            Are you sure you want to leave this workspace?
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" align="center">
          <v-btn block class="white--text text-capitalize" color="#ff575f" @click="leave">{{ $t('leave') }}</v-btn>
        </v-col>
        <v-col cols="6" align="center">
          <v-btn block class="white--text text-capitalize" color="#869399" @click="close">
            {{ $t('deleteCancel') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { setWsLeave } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'leaveDialog',
  props: {
    isLeaveDialog: Boolean,
  },
  data() {
    return {
      wsId: this.$store.getters.selectedWsInfo.wsId,
      userId: this.$store.getters.currentUser.userId,
    }
  },
  methods: {
    async leave() {
      try {
        await this.$store.dispatch('setIsLoading', true)
        let result = await setWsLeave(this, this.wsId, this.userId)
        if (result.isLeave) {
          // notify(this, 'Success', this.$t('updateSuccess'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('updateSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          await this.$store.dispatch('getUserWsList')
          if (this.$store.getters.userInfo && this.$store.getters.userWsList.length > 0) {
            this.$store.commit('setSelectedWsInfo', this.$store.getters.userWsList[0])
            localStorage.setItem('lastSelectedWsInfo', this.$store.getters.userWsList[0])
            await this.$router.replace(`/${this.$store.getters.userWsList[0].wsDomain}/my`).catch(() => {})
            location.reload()
          } else this.$router.replace({ name: 'Workspace' })
        }
      } catch (error) {
        await this.$store.dispatch('setIsLoading', false)
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message
        // notify(this, 'Error', this.errorCode, 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.errorCode,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
      }
    },
    close() {
      this.$emit('closeDialog', 'Leave')
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
}
.v-menu__content {
  z-index: 232 !important;
}
.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
  font-size: 18px;
  width: 100%;
}
</style>
